// validates password length, if length is less than 6 then returns the error message

import { Auth } from "../../util/auth";
import {user, getHeaders} from "./common-api"
import { ChangePasswordDTO } from "./entity/ChangePasswordDto";
import { getURL } from "../../env/url";
function validatePasswordLength(value) {
    if (value.length < 6 && value.length > 0) {
        return 'minimum 6 characters are required';
    }
    return '';
}

function validateConfirmAndNewpassword(newPassword, confirmPassword) {
    if (newPassword != undefined && newPassword != '' && confirmPassword != undefined && confirmPassword != '' && newPassword != confirmPassword) {
        return 'confirm password is not matching with new password';
    }
    return '';
}

function validateChangePasswordSubmitBtn(currentPassword, newPassword, confirmPassword) {
    if (currentPassword == undefined || currentPassword == '' || newPassword == undefined
        || newPassword == '' || confirmPassword == undefined || confirmPassword == '' || newPassword != confirmPassword) {
        document.getElementById("changePasswordBtn").disabled = "disabled";
    } else {
        document.getElementById("changePasswordBtn").disabled = false;
    }
}

export function validateForm() {

    var currentPassword = document.getElementById("currentPassword").value;
    var newPassword = document.getElementById("newPassword").value;
    var confirmPassword = document.getElementById("confirmPassword").value;

    var currPswdErrorMsg = validatePasswordLength(currentPassword);

    var newPassErrorMsg = validatePasswordLength(newPassword);

    var confirmPassErrorMsg = validatePasswordLength(confirmPassword);

    if (confirmPassErrorMsg == undefined || confirmPassErrorMsg == '') {
        confirmPassErrorMsg = validateConfirmAndNewpassword(newPassword, confirmPassword);
    }

    document.getElementById("curPassErrorMsg").innerHTML = currPswdErrorMsg;
    document.getElementById("newPassErrorMsg").innerHTML = newPassErrorMsg;
    document.getElementById("confirmPassErrorMsg").innerHTML = confirmPassErrorMsg;

    validateChangePasswordSubmitBtn(currentPassword, newPassword, confirmPassword);
}

export function checkCurrentPassword() {
    var email = getEmail();
    var password = '';

    password = document.getElementById("currentPassword").value;

    const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/login/newpassword', {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(new ChangePasswordDTO(email, password))
    });

    fetch(myRequest).then(function (body) {
        return body.text();
    }).then(function (data) {
        if (data === 'false') {
            document.getElementById("curPassErrorMsg").innerHTML = 'Enter valid password';
        } else {
            document.getElementById("curPassErrorMsg").innerHTML = '';
        }

    });
}

export function changeNewPassword() {
    var email = getEmail();
    var password = document.getElementById("newPassword").value;
    const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/login/changepassword', {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(new ChangePasswordDTO(email, password)),
    });
    return fetch(myRequest);
}
function getEmail() {
    if (user.email == null) {
        return user.userName;
    } else {
        return user.email;
    }
}


export function changePassword() {
    changeNewPassword().then(response => {
      if (response.status == 200) {
        response.text();
        closeModal();
        Auth.logout();
      }
    });
  }
  export function closeModal(){
    document.getElementById('change-password-modal').classList.remove('show'); 
  }
  